import { ILocation } from 'src/types/Location';

export const MAX_LOCATIONS_ALLOWED = 15;

export const transformLocationsToIds = (
  locations: ILocation[] = []
): string[] => locations.map((loc) => loc.id);

export const maxLocationsAllowedValidation =
  (maxLocations: number) =>
  (locations: ILocation[] = []): boolean | string =>
    locations.length <= maxLocations ||
    `You have exceeded the max number of ${maxLocations} locations`;
